import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

// The shared league URLs, normalised into the app's League Play area:
//
//   qushi.io/join/<INVITE_CODE>  the organiser's invite link — opening it is a
//                                validated invite, with nothing to type
//   qushi.io/join/<league-slug>  the private league's address. NOT access: a
//                                non-member lands on the invite gate
//   qushi.io/leagues/<slug>      a public league, which anyone may open
//
// The path segment is passed through as-is; whether it's a credential or just an
// address is decided by the lookup (see inviteCode.resolveInviteToken).
//
// They live at the root because that's what an organiser hands out, but the
// screens they lead to belong inside the /contest layout (header, sidebar, page
// container). Redirecting rather than mounting them at the root keeps one copy of
// each screen instead of a bare-chrome duplicate.
//
// `replace` so the redirect doesn't sit in history: Back from the league goes
// wherever the user actually came from, not into a bounce loop.
const JoinLinkRedirect = ({ to }) => {
  const { slug } = useParams();
  const { search, hash } = useLocation();

  if (!slug) return <Navigate to="/contest" replace />;

  // Query and hash carry through — email invitations append ?token=…
  return <Navigate to={`${to}/${slug}${search || ""}${hash || ""}`} replace />;
};

export default JoinLinkRedirect;
